import IcNext from "@/assets/icons/ic-next.svg";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  classname?: string;
}

const getPageNumbers = (currentPage: number, totalPages: number) => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  const pages: (number | "...")[] = [];
  if (currentPage <= 2) {
    for (let i = 1; i <= 3; i++) pages.push(i);
    pages.push("...");
    pages.push(totalPages);
  } else if (currentPage >= totalPages - 1) {
    pages.push(1);
    pages.push("...");
    for (let i = totalPages - 2; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    pages.push("...");
    for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
    pages.push("...");
    pages.push(totalPages);
  }
  return pages;
};

export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  classname,
}: PaginationProps) => {
  if (totalPages <= 1) return null;

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  return (
    <div className={`flex items-center justify-center w-full ${classname || ""}`}>
      {/* <span className="text-sm text-[#646464]">
        {currentPage} / {totalPages}페이지
      </span> */}

      <div className="flex items-center gap-4">
        <button
          type="button"
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
          className="group inline-flex items-center gap-2 text-base font-bold disabled:text-[#D8D8D8] text-black hover:opacity-70 transition-opacity"
        >
          <img src={IcNext} alt="Icon Prev" className="rotate-180 group-disabled:opacity-40" />
          Prev
        </button>

        <div className="flex items-center gap-1">
          {getPageNumbers(currentPage, totalPages).map((page, idx) =>
            page === "..." ? (
              <span
                key={`ellipsis-${idx}`}
                className="w-10 h-10 flex items-center justify-center text-sm text-black"
              >
                ...
              </span>
            ) : (
              <button
                key={page}
                type="button"
                onClick={() => handlePageChange(page as number)}
                className={`w-10 h-10 rounded-full text-sm transition-colors ${
                  currentPage === page
                    ? "bg-black/[0.06] font-bold text-[#202020]"
                    : "text-[#202020] hover:bg-black/[0.04]"
                }`}
              >
                {page}
              </button>
            ),
          )}
        </div>

        <button
          type="button"
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
          className="group inline-flex items-center gap-2 text-base font-bold disabled:text-[#D8D8D8] text-black hover:opacity-70 transition-opacity"
        >
          Next
          <img src={IcNext} alt="Icon Next" className="group-disabled:opacity-40" />
        </button>
      </div>
    </div>
  );
};
